var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestStrategyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.5H9.375C9.54076 2.5 9.69973 2.56585 9.81694 2.68306C9.93415 2.80027 10 2.95924 10 3.125V3.75H5V3.125C5 2.95924 5.06585 2.80027 5.18306 2.68306C5.30027 2.56585 5.45924 2.5 5.625 2.5Z",
    stroke: "#383838",
    strokeWidth: 1.06667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 3.75H4.0625C3.54473 3.75 3.125 4.16973 3.125 4.6875V12.1875C3.125 12.7053 3.54473 13.125 4.0625 13.125H10.9375C11.4553 13.125 11.875 12.7053 11.875 12.1875V4.6875C11.875 4.16973 11.4553 3.75 10.9375 3.75Z",
    stroke: "#383838",
    strokeWidth: 1.06667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 6.875H9.6875",
    stroke: "#383838",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 9.375H9.6875",
    stroke: "#383838",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestStrategyIcon);
export default __webpack_public_path__ + "static/media/TestStrategyIcon.6025d915a062551e4f8366712e04c882.svg";
export { ForwardRef as ReactComponent };